import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type BizsolUserInfoResponse = {
  token: string | null;
  user_info: BizsolUserInfo;
  authenticated: boolean;
  redirect_url: string | null;
};
export type BizsolUserInfo = {
  sub: string;
  email: string;
  user_name: string;
  company_name: string;
  company_name_kana: string;
};
type BizsolUserInfoErrorResponse = {
  message?: string[];
};

export const bizsolApiClient = {
  userInfo: async (
    code: string,
  ): Promise<ApiResult<BizsolUserInfoResponse, BizsolUserInfoErrorResponse>> => {
    return await axiosClient.get('/company/auth/bizsol/' + code, {});
  },
};
